import { render, staticRenderFns } from "./IconRewardToReceive.vue?vue&type=template&id=17735a1e"
import script from "./IconRewardToReceive.vue?vue&type=script&lang=js"
export * from "./IconRewardToReceive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports